import * as React from 'react';
import {ArrowsDir} from '../../../../../../constants';
import {NavArrowDown, NavArrowLeft, NavArrowRight, NavArrowUp} from '../../../../../../icons/dist';

export {ArrowsDir};
export interface NavigationArrowProps {
  direction: ArrowsDir;
}

export const DataHook = (direction: ArrowsDir) => {
  return `arrow-${direction}`;
};

export const NavigationArrow: React.FunctionComponent<NavigationArrowProps> = ({direction}) => {
  const props = {size: '20px', 'data-hook': DataHook(direction)};
  switch (direction) {
    case ArrowsDir.UP:
      return <NavArrowUp {...props} />;
    case ArrowsDir.DOWN:
      return <NavArrowDown {...props} />;
    case ArrowsDir.LEFT:
      return <NavArrowLeft {...props} />;
    case ArrowsDir.RIGHT:
      return <NavArrowRight {...props} />;
  }
};
